<div class="d-flex flex-column align-items-center justify-content-center text-center" style="min-height: 40vh;">
  <div class="spinner-border text-primary" role="status" aria-hidden="true"></div>
  <div class="mt-3">Trwa logowanie...</div>
</div>
